<template lang="pug">
	.track-providers
		.track-providers-list(v-if="atLeastOneEnabled")
			.track-provider(v-for="(providerProps, providerKey) in settingValue" v-if="providerProps.enabled")
				.track-provider-name
					span.track-provider-title {{providerProps.title}}
					div
						span.track-provider-description.text-muted {{providerProps.description}}
				.track-provider-remove(@click="removeProvider(providerKey)")
					i.fa.fa-times
		.add-new-provider
			select.custom-select.custom-select-sm(v-on:change="addNewProvider($event.target.value)")
				option(:selected="true" value="none") Add new tracking provider
				option(v-for="(providerProps, providerKey) in settingValue" v-if="!providerProps.enabled" :selected="false" :value="providerKey") {{providerProps.title}}
</template>

<script>

	import Screen 				from './../../../mixins/screen';

	import { Creative } 			from './../../../services/Creative';
	import { Settings } 		from './../../../services/Settings';
	import { Version } 			from './../../../services/Version';

	export default {
		name: "TrackingProviders",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Switched", "Selected Version Fully Loaded"]
		},
		props: ['setting'],
		data() {

			this.Creative = Creative;
			this.Settings = Settings;

			this.settingValue = {};
			this.atLeastOneEnabled = false;

			return {
				showed: true
			}

		},
		mounted() {

			//Сообщаем компоненту что он должен обновляться при изменении указанных настроек активной версии креатива
			this.addUpdateEvent([`Selected Version Setting Changed:track-providers`]);

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion || !this.setting || !Settings.isSettingExist(this.setting.codename)) return console.log('TrackingProviders collectData FAILED', this.setting?.['codename'], Version.SelectedVersion?.id, this.setting?.['version_id']);

				this.settingValue = Settings.getSettingValue(this.setting.codename) || [];
				this.atLeastOneEnabled = !!_.find(this.settingValue, "enabled");

			},
			addNewProvider(providerKey) {

				if (providerKey === "none") return;

				let providerProps = this.settingValue[providerKey];

				providerProps.enabled = true;

				this.atLeastOneEnabled = !!_.find(this.settingValue, "enabled");

				this.$forceUpdate();

				this.delaySave();

				Broadcast.call("Selected Version Tracking Providers Changed");

			},
			removeProvider(providerKey) {

				let providerProps = this.settingValue[providerKey];

				providerProps.enabled = false;

				this.atLeastOneEnabled = !!_.find(this.settingValue, "enabled");

				this.$forceUpdate();

				this.delaySave();

				Broadcast.call("Selected Version Tracking Providers Changed");

			},
			delaySave() {

				clearTimeout(this.saveTimeout);
				this.saveTimeout = setTimeout(() => {

					Server.sendToSocket({
						UpdateCreativeVersionSetting: {
							versionId: Version.SelectedVersion.id,
							settingCodename: this.setting.codename,
							value: this.settingValue
						}
					});

					console.log(this.settingValue);

				}, 200);

			}
		}
	}
</script>

<style lang="sass">

	.track-providers
		display: flex
		justify-content: space-between
		user-select: none
		position: relative
		flex-direction: column

		.custom-select
			cursor: pointer
			color: #fff
			width: auto
			background: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'%3e%3cpath fill='%23ffffff' d='M2 0L0 2h4zm0 5L0 3h4z'/%3e%3c/svg%3e") no-repeat right 0.75rem center/8px 10px
			background-color: #343b41
			border: 1px solid #23282c
			margin-top: 0
			float: none !important

			&.selected
				background-color: #4dbd74

		.track-providers-list
			position: relative
			margin-top: 5px
			border: 1px solid #23282c
			border-radius: 5px
			background-color: #343b41
			font-size: 12px
			overflow: hidden

			.track-provider
				display: flex
				flex-direction: row
				justify-content: space-between
				padding: 0 5px 0px 5px
				position: relative
				user-select: none

				&:not(:first-child)
					border-top: 1px solid rgba(0, 0, 0, 0.1)

				&:hover
					background-color: #2f363c

				.track-provider-name
					display: flex
					flex-direction: column
					justify-content: space-between
					padding-bottom: 3px

					.track-provider-title
						user-select: none
						margin: auto 0
						font-size: 13px

				.track-provider-remove
					cursor: pointer
					transition: 0.2s
					padding: 4px 7px
					font-size: 14px
					color: #fff
					display: flex
					flex-direction: column
					align-items: center
					justify-content: center

					&:hover
						color: #20a8d8

					.fa-times
						padding-top: 0

</style>
